import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const Asterisk = styled('span')(() => ({
  color: 'red',
}));

const CustomFormLabel = styled(
  ({ required, margin, children, ...props }) => (
    <Typography
      variant="subtitle1"
      fontWeight={600}
      {...props}
      component="label"
    >
      {children} {required && <Asterisk>*</Asterisk>}
    </Typography>
  ),
  {
    shouldForwardProp: (prop) => prop !== 'margin',
  }
)(({ margin }) => ({
  marginBottom: margin || '5px',
  marginTop: margin || '25px',
  display: 'block',
}));

export default CustomFormLabel;
